<template>
    <div
        class="relative inline-block rounded-sm cursor-pointer"
        :class="squareSize"
        :style="{ backgroundColor: modelValue }"
        @click="onPickerClick"
    >
        <input
            ref="colorInput"
            v-model="modelValue"
            type="color"
            style="opacity: 0; pointer-events: none"
            @change="onColorChange"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { ComponentSize } from '@src/Common/DataGrid/types';

const emit = defineEmits<{
    (event: 'update:modelValue', content: string | null): void;
}>();

interface Props {
    modelValue?: string | null;
    dusk?: string | null;
    size?: ComponentSize;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: '#cccccc',
    dusk: null,
    size: 'base',
});

const modelValue = ref(props.modelValue || '#cccccc');

// Watch for external prop changes (e.g. config loaded from DB)
watch(() => props.modelValue, (newVal) => {
    modelValue.value = newVal || '#cccccc';
});

watch(modelValue, (value: string) => {
    emit('update:modelValue', value);
});

const colorInput = ref<HTMLInputElement | null>(null);

const onPickerClick = () => {
    colorInput.value?.click();
};

const onColorChange = () => {};

const squareSize = computed((): string => {
    const sizes = {
        xs: 'w-4 h-4',
        sm: 'w-5 h-5',
        base: 'w-6 h-6',
        lg: 'w-8 h-8',
        xl: 'w-10 h-10',
    };
    return sizes[props.size] ?? sizes.base;
});
</script>
